import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import type { FC } from 'react';
import { bindDialog } from 'material-ui-popup-state/hooks';
import type { usePopupState } from 'material-ui-popup-state/hooks';
import AddFacebookPageForm from './AddFacebookPageForm';
import type { AddFacebookPageResponse } from '../api';
import { Close } from '@mui/icons-material';

interface AddFacebookPageDialogProps {
  onSuccess?: (data: AddFacebookPageResponse) => void;
  popupState: ReturnType<typeof usePopupState>;
}

const AddFacebookPageDialog: FC<AddFacebookPageDialogProps> = ({
  onSuccess,
  popupState,
}) => {
  const handleClose = () => {
    popupState.close();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      {...bindDialog(popupState)}
      onClose={() => {
        handleClose();
      }}
      PaperProps={{
        sx: { maxWidth: 520, minHeight: 156, width: '90%', px: 1, pb: 1.5 },
      }}
    >
      <DialogContent sx={{ width: '100%' }}>
        <AddFacebookPageForm
          onSuccess={onSuccess}
          titleForm={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Typography variant={'h4'}>Add Facebook Page</Typography>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
          }
          sx={{ maxWidth: '100%' }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddFacebookPageDialog;
